// Shared reviews data for SecureAI
// NOTE: This is a small snapshot subset for UI rendering, not the full set of client reviews.
// Update with new highlights; avoid implying only these exist.
export const reviews = [
  {
    id: 1,
    author: 'Jennifer Rocha',
    meta: '2 reviews · 1 photo',
    date: '2 weeks ago',
    text: `I’ve used SecureAI for multiple stadium events and always felt confident in the level of safety they provided. The guards were professional, well-trained, and made sure everything stayed under control. Management was great to work with too.`
  },
  {
    id: 2,
    author: 'Yanet Teshager',
    meta: '3 reviews',
    date: '3 weeks ago',
    text: `I’ve been working with this security company for about a year now, and I couldn’t be happier with their services. Before them, we dealt with all kinds of problems from other security companies—things like guards not showing up. SecureAI changed everything.`
  },
  {
    id: 3,
    author: 'Yuele Tesfalem',
    meta: 'New reviewer',
    date: '2 days ago',
    text: `We’ve had about four different security companies over the past few years, and none of them really worked out. This past year with SecureAI has been the first time we’ve actually been happy with our security. They’re reliable, professional, and handle things the right way. They keep us updated every night and have stopped several problems before they got worse. Highly recommend for apartment properties in higher crime areas.`
  }
];
